import './style/index.less';
import ImportMemberTip from './ImportMemberTip';

export default ImportMemberTip;
